export default __webpack_public_path__ + "static/banner-website-development.jpeg-e9a6c3043d80f7022273a49d543cc0f3.jpg";